import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import { createTheme, markThemeVersion } from "../../../lib/theming/ThemeHelpers";
import { BasicTheme, BasicThemeClassForExtension } from "../BasicTheme";
export var LightTheme5_0 = createTheme({
  themeClass: /*#__PURE__*/function (_BasicThemeClassForEx) {
    function LightTheme5_0() {
      return _BasicThemeClassForEx.apply(this, arguments) || this;
    }
    _inheritsLoose(LightTheme5_0, _BasicThemeClassForEx);
    return LightTheme5_0;
  }(BasicThemeClassForExtension),
  prototypeTheme: BasicTheme,
  themeMarkers: [markThemeVersion('5.0')]
});